/**
 * SmartSize Integration for Nova Theme
 * Handles SmartSize button functionality with proper error handling and fallbacks
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeSmartSizeButtons();
  });

  document.addEventListener('shopify:section:load', function(event) {
    initializeSmartSizeButtons();
  });

  document.addEventListener('shopify:block:select', function(event) {
    initializeSmartSizeButtons();
  });

  // Handle section selection in editor
  document.addEventListener('shopify:section:select', function(event) {
    initializeSmartSizeButtons();
  });

  function initializeSmartSizeButtons() {
    const smartSizeButtons = document.querySelectorAll('.smartsize-trigger');

    smartSizeButtons.forEach(function(button) {
      button.removeEventListener('click', handleSmartSizeClick);
      button.addEventListener('click', handleSmartSizeClick);
    });
  }

  function handleSmartSizeClick(event) {
    event.preventDefault();

    if (!window.smartsize) {
      console.warn('SmartSize API not available');
      return;
    }

    if (typeof window.smartsize.openModal !== 'function') {
      console.warn('SmartSize openModal method not available');
      return;
    }

    if (window.smartsize.hasChart && typeof window.smartsize.hasChart === 'function') {
      if (!window.smartsize.hasChart()) {
        console.log('No size chart available for this product');
        return;
      }
    }

    try {
      window.smartsize.openModal();
    } catch (error) {
      console.error('Error opening SmartSize modal:', error);
    }
  }

  function waitForSmartSize(callback, maxAttempts = 30) {
    if (window.smartsize) {
      callback();
    } else if (maxAttempts > 0) {
      setTimeout(() => waitForSmartSize(callback, maxAttempts - 1), 500);
    } else {
      console.warn('SmartSize API failed to load after 15 seconds');
    }
  }

  window.waitForSmartSize = waitForSmartSize;

  waitForSmartSize(function() {
    console.log('SmartSize API is ready!');
    initializeSmartSizeButtons();
  });

  if (window.Shopify && window.Shopify.designMode) {
    setTimeout(function() {
      initializeSmartSizeButtons();
    }, 1000);
  }

})();
